<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 2.25L3 5.25M3 5.25L6 8.25M3 5.25H15M12 15.75L15 12.75M15 12.75L12 9.75M15 12.75H3" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>